import { Link } from "react-router-dom";
import { CITIES, CONTACT } from "@/lib/data";

const slugify = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

/**
 * Understated local SEO block: lists every Miami-Dade community we serve and
 * links each to its per-city landing page. Kept low-key (small, muted) so it
 * doesn't compete with the main content, but the city names are clearly styled
 * as clickable links and stay out of the primary navigation.
 */
export default function ServiceAreasSeo({ service = "commercial waste management services" }) {
  return (
    <section className="bg-[#FBFAF8] border-t border-[#E7E5DF] py-10" data-testid="service-areas-seo">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <p className="font-mono-tech text-[11px] uppercase tracking-[0.22em] text-emerald-700/70 mb-3">
          Miami-Dade Service Areas
        </p>
        <p className="text-slate-500 text-sm leading-relaxed">
          EWS proudly provides {service} throughout Miami and all of Miami-Dade County — serving{" "}
          {CITIES.map((c, i) => (
            <span key={c}>
              <Link
                to={`/dumpster-rental/${slugify(c)}`}
                className="text-slate-600 underline decoration-dotted decoration-slate-300 underline-offset-2 hover:text-emerald-700 hover:decoration-emerald-500 transition-colors"
                data-testid={`area-link-${slugify(c)}`}
              >
                {c}, FL
              </Link>
              {i < CITIES.length - 1 ? (i === CITIES.length - 2 ? " and " : ", ") : ""}
            </span>
          ))}
          . Call{" "}
          <a href={CONTACT.phoneHref} className="text-emerald-700 font-medium hover:underline">
            {CONTACT.phone}
          </a>{" "}
          to confirm same-week availability in your neighborhood.
        </p>
      </div>
    </section>
  );
}
